"use client";

import React from "react";
import { Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  const defaultLinks = [{
    id: "fallback-1",
    label: "Consulting",
    href: "#"
  }, {
    id: "fallback-2",
    label: "Sourcing",
    href: "#"
  }, {
    id: "fallback-3",
    label: "Management",
    href: "#"
  }];
  const displayItems = menuItems && menuItems.length > 0 ? menuItems : defaultLinks;
  return <ul className="space-y-3">
      {displayItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const contactInfo = {
    phone: "Phone number not specified in input; please provide",
    email: "Email address not specified in input; please provide",
    address: "Headquarters not specified in input; please provide"
  };
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  return <section id="footer" className="dark bg-background text-foreground border-t border-primary pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="inline-block mb-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/starboard_aviation_logo_refined.png" alt="Starboard Aviation Group" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs">
              Precision Aviation. Elevated. Providing elite private aviation services for UHNW individuals and family offices globally.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase mb-6 text-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase mb-6 text-foreground">
              Contact
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Phone className="size-4 shrink-0 text-primary mt-0.5" />
                <span>203-751-1897</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Mail className="size-4 shrink-0 text-primary mt-0.5" />
                <span>jwallace@starboardaviationgroup.com<br /></span>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-4 shrink-0 text-primary mt-0.5" />
                <span>Atlanta, GA</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-sm font-semibold tracking-wider uppercase mb-6 text-foreground">
              Connect
            </h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} className="h-10 w-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-background hover:bg-foreground hover:border-foreground transition-all duration-300" aria-label={social.label}>
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {currentYear} <Link to="/">Starboard Aviation Group</Link> (SAG). All rights reserved.
          </p>
          <p className="text-xs font-medium tracking-widest uppercase text-muted-foreground">
            Aviation Excellence
          </p>
        </div>
      </div>
    </section>;
}